module.exports = {"title":"알림 수신 설정","push":"알림","sms":"문자(SMS)","email":"이메일"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/se211.json
// module id = fUvo
// module chunks = 2